import { FunctionComponent, useCallback } from 'react';

const Signin: FunctionComponent<RewindSlideProps> = (props) => {
  const { active } = props;
  const openModal = useCallback(() => {
    const event = new Event('OdWebsite_OpenSignIn');
    document.dispatchEvent(event);
  }, []);

  return (
    <>
      <h2
        className="text-2xl md:text-4xl
          mt-0 landscape:mt-[10px] md:landscape:mt-0
          slide-up"
      >
        It&apos;s time to roll the credits on 2023!
        <br/>
        Sign in to see your
        {' '}
        <span className="text-dark-tangerine">personalised results</span>
      </h2>
      <button
        type="button"
        className="sbs-button sbs-button-primary
          mt-[81px] landscape:mt-[35px] md:landscape:mt-[81px] w-[218px]
          slide-down"
        data-modal-target="login-modal"
        data-modal-show="login-modal"
        onClick={openModal}
        tabIndex={active ? 0 : -1}
      >
        Sign in
      </button>
    </>
  );
};

export default Signin;
